import ValidService from "../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  id: undefined, // optional - Mã tự sinh
  dai_ly_id: undefined, // required, ref: agt_dai_ly - ID đại lý
  so_tien: undefined, // required, min: 0 - Tiền thanh toán
  danh_sach_don_hang: [
    // optional - Danh sách đơn hàng được thanh toán
    {
      don_hang_id: undefined, // required, ref: ord_don_hang - ID đơn hàng
      ma_don_hang: undefined, // required, minLength: 1 - Mã đơn hàng
    },
  ],
  // optional - Thanh toán cho tháng mấy (áp dụng cho các đại lý thanh toán theo tháng)
  ky_thanh_toan: {
    thang: undefined, // optional, min: 1, max: 12 - Tháng
    nam: undefined, // optional - Năm
  },
  ky_thanh_toan_str: undefined,
  noi_dung: undefined, // optional - Nội dung thanh toán
  file_dinh_kem: [], // optional - File đính kèm
  dai_ly_xac_nhan: undefined, // optional - Đại lý xác nhận
  vt_xac_nhan: undefined, // optional - Việt Tộc xác nhận
  thoi_diem_tao: undefined, // required - Thời điểm tạo
  nguoi_tao_id: undefined, // required, ref: mushroom_user - Mã người tạo
  thoi_diem_cap_nhat: undefined, // required - Thời điểm cập nhật cuối
  nguoi_cap_nhat_id: undefined, // required, ref: mushroom_user - Mã người cập nhật cuối
};

// validation form
model.validForm = {};
model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "-thoi_diem_tao",
  defaultSort: ["thoi_diem_tao", "descending"],
  filters: "",
  fields:
    "id,dai_ly_id,so_tien,danh_sach_don_hang,ky_thanh_toan,noi_dung,file_dinh_kem,dai_ly_xac_nhan,vt_xac_nhan,thoi_diem_tao,nguoi_tao_id,thoi_diem_cap_nhat,nguoi_cap_nhat_id",
  recordSelected: [],

  dataSearch: {
    value: {
      dai_ly_id: "",
      "ky_thanh_toan.thang": "",
      "ky_thanh_toan.nam": "",
      thoi_diem_tao: "",
    },
    operator: {
      dai_ly_id: "",
      "ky_thanh_toan.thang": "",
      "ky_thanh_toan.nam": "",
      thoi_diem_tao: "",
    },
  },
};

export default model;
